import type { CommissionLedgerEntry } from './types';

const partner = Object.freeze({
  id: '00000000-0000-4000-8000-000000000101',
  code: 'PARTNER-A',
  name: 'Partner A',
});

export const commissionLedgerFixtures = Object.freeze<readonly CommissionLedgerEntry[]>([
  {
    id: '00000000-0000-4000-8000-000000000801',
    partner,
    agentId: '00000000-0000-4000-8000-000000000201',
    agentCode: 'AGENT-A',
    beneficiaryType: 'AFFILIATE_MEMBER',
    beneficiaryId: '00000000-0000-4000-8000-000000000301',
    beneficiaryUsername: 'member-a',
    entryType: 'REVERSAL',
    signedAmount: '-12.340000',
    currencyCode: 'THB',
    currencyMinorUnit: 2,
    source: {
      transactionId: '00000000-0000-4000-8000-000000000401',
      partnerTransactionId: 'partner-txn-a',
      calculationId: '00000000-0000-4000-8000-000000000501',
      reversalId: '00000000-0000-4000-8000-000000000601',
      sourceEntryId: null,
      approvalRequestId: null,
      adjustmentId: null,
    },
    walletPosting: {
      entryId: '00000000-0000-4000-8000-000000000901',
      walletId: '00000000-0000-4000-8000-000000000902',
      entryType: 'COMMISSION_REVERSAL',
      availableDelta: '-12.340000',
      availableAfter: '87.660000',
      expiresAt: null,
      effectiveAt: '2026-07-21T23:00:00-04:00',
    },
    reasonCode: 'TRANSACTION_REVERSED',
    reason: 'Original transaction reversed',
    effectiveAt: '2026-07-21T23:00:00-04:00',
    createdAt: '2026-07-22T10:00:00+07:00',
    createdBy: '00000000-0000-4000-8000-000000000001',
  },
  {
    id: '00000000-0000-4000-8000-000000000802',
    partner,
    agentId: '00000000-0000-4000-8000-000000000201',
    agentCode: 'AGENT-A',
    beneficiaryType: 'AGENT',
    beneficiaryId: '00000000-0000-4000-8000-000000000201',
    beneficiaryUsername: null,
    entryType: 'EARN',
    signedAmount: '25.500000',
    currencyCode: 'USD',
    currencyMinorUnit: 2,
    source: {
      transactionId: '00000000-0000-4000-8000-000000000402',
      partnerTransactionId: 'partner-txn-b',
      calculationId: '00000000-0000-4000-8000-000000000502',
      reversalId: null,
      sourceEntryId: null,
      approvalRequestId: null,
      adjustmentId: null,
    },
    walletPosting: null,
    reasonCode: null,
    reason: null,
    effectiveAt: '2026-07-22T11:00:00+07:00',
    createdAt: '2026-07-22T11:00:01+07:00',
    createdBy: '00000000-0000-4000-8000-000000000001',
  },
]);
